import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14b67c53"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "FTLOrderUpdate" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "text-xl font-semibold" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))
const _hoisted_5 = {
  key: 2,
  class: "mt-6"
}
const _hoisted_6 = { class: "flex flex-col items-center" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold text-gray-400" }, "Загрузка заказа...", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold text-red-400" }, "Произошла ошибка при загрузке заказа", -1))
const _hoisted_9 = {
  key: 3,
  class: "mt-6"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-2 flex items-center" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold mt-2" }, "Перевозчик", -1))
const _hoisted_12 = { class: "flex items-center" }
const _hoisted_13 = { class: "flex items-center" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold mt-2" }, "Компания", -1))
const _hoisted_15 = {
  key: 4,
  class: "mt-5"
}
const _hoisted_16 = { class: "flex items-center justify-between" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-semibold" }, "Доп услуги при заборе", -1))
const _hoisted_18 = { class: "mt-1" }
const _hoisted_19 = { class: "grid grid-cols-3 gap-3" }
const _hoisted_20 = { class: "flex items-center justify-between" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1))
const _hoisted_22 = { class: "flex items-center" }
const _hoisted_23 = { class: "flex items-center" }
const _hoisted_24 = { key: 5 }
const _hoisted_25 = { class: "flex items-center justify-between" }
const _hoisted_26 = { class: "text-lg font-semibold" }
const _hoisted_27 = { class: "mt-1" }
const _hoisted_28 = { class: "grid grid-cols-3 gap-3" }
const _hoisted_29 = { class: "flex items-center justify-between" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1))
const _hoisted_31 = { class: "flex items-center" }
const _hoisted_32 = { class: "flex items-center" }
const _hoisted_33 = { class: "flex items-center justify-end mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ftl_create_additional_service = _resolveComponent("ftl-create-additional-service")!
  const _component_alert = _resolveComponent("alert")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_loader = _resolveComponent("loader")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_cheap = _resolveComponent("cheap")!
  const _component_the_select = _resolveComponent("the-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.state.ftl_order && _ctx.additional_state.is_open)
      ? (_openBlock(), _createBlock(_component_ftl_create_additional_service, {
          key: 0,
          "is-loading": _ctx.state.is_loading,
          "order-id": _ctx.state.ftl_order.id,
          "sender-services": _ctx.state.ftl_order.additional_service,
          sender: _ctx.state.ftl_order.sender,
          stock: _ctx.additional_state.stock,
          onCancel: _ctx.toggleAdditionalService,
          onSubmitted: _ctx.onSubmitServices
        }, null, 8, ["is-loading", "order-id", "sender-services", "sender", "stock", "onCancel", "onSubmitted"]))
      : _createCommentVNode("", true),
    (_ctx.avr_state.already_have_1c)
      ? (_openBlock(), _createBlock(_component_alert, {
          key: 1,
          class: "red mb-6"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" По данному ФТЛ заказу уже проведен документ в 1с ")
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, " Редактирование FTL заказа (ID: " + _toDisplayString(_ctx.$route.params.order_id) + ") ", 1),
      _createVNode(_component_the_button, {
        class: "second small text",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
      }, {
        default: _withCtx(() => [
          _hoisted_4,
          _createTextVNode(" Назад ")
        ]),
        _: 1
      })
    ]),
    (_ctx.state.is_loading || _ctx.state.is_failed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (_ctx.state.is_loading)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_7,
                  _createVNode(_component_loader, { class: "primary mt-1" })
                ], 64))
              : (_ctx.state.is_failed)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _hoisted_8,
                    _createVNode(_component_the_button, {
                      class: "primary small mt-2",
                      onClick: _ctx.loadFTLOrder
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Перезагрузить ")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ], 64))
                : _createCommentVNode("", true)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createVNode(_component_the_input, {
            value: _ctx.form_state.dop_order_number,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form_state.dop_order_number) = $event)),
            placeholder: "Номер заказа заказчика"
          }, null, 8, ["value"]),
          (_ctx.state.ftl_order?.is_need_car)
            ? (_openBlock(), _createBlock(_component_the_input, {
                key: 0,
                class: "mt-2",
                value: _ctx.form_state.cost_price,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form_state.cost_price) = $event)),
                placeholder: "Себестоимость за перевозку",
                "is-invalid": _ctx.form_state$.cost_price.$error
              }, null, 8, ["value", "is-invalid"]))
            : _createCommentVNode("", true),
          _hoisted_10,
          (_ctx.state.ftl_order?.is_need_car && _ctx.isFtlTypeTwo)
            ? (_openBlock(), _createBlock(_component_the_input, {
                key: 1,
                class: "mt-2",
                value: _ctx.form_state.auto_count,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form_state.auto_count) = $event)),
                placeholder: "Количество авто",
                "is-invalid": _ctx.form_state$.auto_count.$error
              }, null, 8, ["value", "is-invalid"]))
            : _createCommentVNode("", true),
          (_ctx.state.ftl_order?.is_need_car && _ctx.isFtlTypeTwo)
            ? (_openBlock(), _createBlock(_component_the_input, {
                key: 2,
                class: "mt-2",
                value: _ctx.form_state.auto_duration,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form_state.auto_duration) = $event)),
                placeholder: "Отработанные часы для себестоимости",
                "is-invalid": _ctx.form_state$.auto_duration.$error
              }, null, 8, ["value", "is-invalid"]))
            : _createCommentVNode("", true),
          (_ctx.state.ftl_order?.is_need_car)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                _hoisted_11,
                _createVNode(_component_the_select, {
                  class: "mt-1",
                  value: _ctx.form_state.carrier_id,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form_state.carrier_id) = $event)),
                  "is-invalid": _ctx.form_state$.carrier_id.$error,
                  placeholder: "Перевозчик",
                  options: _ctx.data_state.carriers.list,
                  loading: _ctx.data_state.carriers.is_loading,
                  failed: _ctx.data_state.carriers.is_failed,
                  "infinite-scroll": "",
                  disabled: _ctx.isCarrierDisabled,
                  onRefresh: _cache[6] || (_cache[6] = ($event: any) => (_ctx.loadCarriers(_ctx.data_state.carriers.pagination.current_page))),
                  onLoadmore: _cache[7] || (_cache[7] = ($event: any) => (_ctx.loadMoreCarriers(_ctx.data_state.carriers.pagination.current_page + 1))),
                  onSearch: _ctx.searchCarriers,
                  onOptionBySearch: _ctx.unshiftFindedCarrier
                }, {
                  "selected-option": _withCtx(({ option }) => [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("span", null, _toDisplayString(option.name), 1),
                      _createVNode(_component_cheap, {
                        class: _normalizeClass(_ctx.getNdsClass(option.is_nds))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.getNdsText(option.is_nds)), 1)
                        ]),
                        _: 2
                      }, 1032, ["class"])
                    ])
                  ]),
                  option: _withCtx(({ option }) => [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("span", null, _toDisplayString(option.name), 1),
                      _createVNode(_component_cheap, {
                        class: _normalizeClass(_ctx.getNdsClass(option.is_nds))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.getNdsText(option.is_nds)), 1)
                        ]),
                        _: 2
                      }, 1032, ["class"])
                    ])
                  ]),
                  _: 1
                }, 8, ["value", "is-invalid", "options", "loading", "failed", "disabled", "onSearch", "onOptionBySearch"])
              ], 64))
            : _createCommentVNode("", true),
          _hoisted_14,
          _createVNode(_component_the_select, {
            class: "mt-1",
            value: _ctx.form_state.company_id,
            "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form_state.company_id) = $event)),
            placeholder: "Компания",
            options: _ctx.data_state.companies.list,
            loading: _ctx.data_state.companies.is_loading,
            failed: _ctx.data_state.companies.is_failed,
            "infinite-scroll": "",
            onRefresh: _cache[9] || (_cache[9] = ($event: any) => (_ctx.loadCompanies(_ctx.data_state.companies.pagination.current_page))),
            onLoadmore: _cache[10] || (_cache[10] = ($event: any) => (_ctx.loadMoreCompanies(_ctx.data_state.companies.pagination.current_page + 1))),
            onSearch: _ctx.searchCompanies,
            onOptionBySearch: _ctx.unshiftFindedCompany
          }, null, 8, ["value", "options", "loading", "failed", "onSearch", "onOptionBySearch"]),
          (Boolean(_ctx.form_state.additional_service))
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createVNode(_component_the_button, {
                    disabled: !_ctx.isCanAddService,
                    class: "primary small",
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.toggleAdditionalService()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Добавить доп услугу ")
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _createElementVNode("p", _hoisted_18, " Адрес: " + _toDisplayString(_ctx.state.ftl_order.sender && _ctx.state.ftl_order.sender.full_address
                            ? _ctx.state.ftl_order.sender.full_address
                            : '-'), 1),
                _createElementVNode("div", _hoisted_19, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form_state.additional_service, (additional_service, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: `FormStateAdditionalService-${i}`,
                      class: "mt-2"
                    }, [
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("span", null, _toDisplayString(additional_service.type_name), 1),
                        (
                                    _ctx.havePermissions([
                                        'additional-service-value-delete',
                                        'all-root-permission',
                                    ])
                                )
                          ? (_openBlock(), _createBlock(_component_the_button, {
                              key: 0,
                              loading: _ctx.delete_additional_service_state.is_loading,
                              class: "red text small",
                              hint: "Удалить",
                              onClick: ($event: any) => (_ctx.deleteAdditionalService(i, additional_service.id))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_21
                              ]),
                              _: 2
                            }, 1032, ["loading", "onClick"]))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode(_component_the_input, {
                        placeholder: "Количество",
                        value: additional_service.value,
                        "onUpdate:value": ($event: any) => ((additional_service.value) = $event)
                      }, null, 8, ["value", "onUpdate:value"]),
                      _createVNode(_component_the_input, {
                        class: "mt-2",
                        placeholder: "Продолжительность (клиенту)",
                        value: additional_service.duration_client,
                        "onUpdate:value": ($event: any) => ((additional_service.duration_client) = $event)
                      }, null, 8, ["value", "onUpdate:value"]),
                      _createVNode(_component_the_input, {
                        class: "mt-2",
                        placeholder: "Продолжительность (себестоимость)",
                        value: additional_service.duration,
                        "onUpdate:value": ($event: any) => ((additional_service.duration) = $event)
                      }, null, 8, ["value", "onUpdate:value"]),
                      _createVNode(_component_the_input, {
                        class: "mt-2",
                        placeholder: "Себестоимость за час",
                        value: additional_service.cost_per_hour,
                        "onUpdate:value": ($event: any) => ((additional_service.cost_per_hour) = $event)
                      }, null, 8, ["value", "onUpdate:value"]),
                      _createVNode(_component_the_input, {
                        class: "mt-2",
                        placeholder: "Выставление клиенту за час",
                        value: additional_service.paid_price_per_hour,
                        "onUpdate:value": ($event: any) => ((additional_service.paid_price_per_hour) = $event)
                      }, null, 8, ["value", "onUpdate:value"]),
                      _createVNode(_component_the_input, {
                        class: "mt-2",
                        placeholder: "Общая себестоимость",
                        value: _ctx.getCostTotal(additional_service),
                        disabled: ""
                      }, null, 8, ["value"]),
                      _createVNode(_component_the_input, {
                        class: "mt-2",
                        placeholder: "Выставление клиенту",
                        value: _ctx.getPaidPriceTotal(additional_service),
                        disabled: ""
                      }, null, 8, ["value"]),
                      _createVNode(_component_the_select, {
                        class: "mt-2",
                        value: additional_service.carrier_id,
                        "onUpdate:value": [($event: any) => ((additional_service.carrier_id) = $event), 
                                (newValue) => _ctx.onCarrierChange(newValue, additional_service)
                            ],
                        placeholder: "Выберите перевозчика",
                        label: "name",
                        "search-by": "name",
                        "select-by": "id",
                        options: _ctx.data_state.carriers.list,
                        loading: _ctx.data_state.carriers.is_loading,
                        failed: _ctx.data_state.carriers.is_failed,
                        "error-text": "При получении списка перевозчиков произошла ошибка",
                        "infinite-scroll": "",
                        onRefresh: _cache[12] || (_cache[12] = ($event: any) => (_ctx.loadCarriers(_ctx.data_state.carriers.pagination.current_page))),
                        onLoadmore: _cache[13] || (_cache[13] = ($event: any) => (
                                _ctx.loadMoreCarriers(_ctx.data_state.carriers.pagination.current_page + 1)
                            ))
                      }, {
                        "selected-option": _withCtx(({ option }) => [
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("span", null, _toDisplayString(option.name), 1),
                            _createVNode(_component_cheap, {
                              class: _normalizeClass(_ctx.getNdsClass(option.is_nds))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.getNdsText(option.is_nds)), 1)
                              ]),
                              _: 2
                            }, 1032, ["class"])
                          ])
                        ]),
                        option: _withCtx(({ option }) => [
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("span", null, _toDisplayString(option.name), 1),
                            _createVNode(_component_cheap, {
                              class: _normalizeClass(_ctx.getNdsClass(option.is_nds))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.getNdsText(option.is_nds)), 1)
                              ]),
                              _: 2
                            }, 1032, ["class"])
                          ])
                        ]),
                        _: 2
                      }, 1032, ["value", "onUpdate:value", "options", "loading", "failed"])
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          (Boolean(_ctx.form_state.stock_delivery_notes.length))
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form_state.stock_delivery_notes, (stock, idx) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: `stock-${idx}`,
                    class: "mt-5"
                  }, [
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("h2", _hoisted_26, _toDisplayString(stock.directionName), 1),
                      _createVNode(_component_the_button, {
                        disabled: !_ctx.isCanAddService,
                        class: "primary small",
                        onClick: ($event: any) => (_ctx.toggleAdditionalService(stock))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Добавить доп услугу ")
                        ]),
                        _: 2
                      }, 1032, ["disabled", "onClick"])
                    ]),
                    _createElementVNode("p", _hoisted_27, "Адрес: " + _toDisplayString(stock.receiver ? stock.receiver.address : '-'), 1),
                    _createElementVNode("div", _hoisted_28, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stock.additional_service, (additional_service, i) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: `FormStateAdditionalService-${i}`,
                          class: "mt-2"
                        }, [
                          _createElementVNode("div", _hoisted_29, [
                            _createElementVNode("span", null, _toDisplayString(additional_service.type_name), 1),
                            (
                                        _ctx.havePermissions([
                                            'additional-service-value-delete',
                                            'all-root-permission',
                                        ])
                                    )
                              ? (_openBlock(), _createBlock(_component_the_button, {
                                  key: 0,
                                  loading: _ctx.delete_additional_service_state.is_loading,
                                  class: "red text small",
                                  hint: "Удалить",
                                  onClick: ($event: any) => (_ctx.deleteAdditionalService(i, additional_service.id))
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_30
                                  ]),
                                  _: 2
                                }, 1032, ["loading", "onClick"]))
                              : _createCommentVNode("", true)
                          ]),
                          _createVNode(_component_the_input, {
                            placeholder: "Количество",
                            value: additional_service.value,
                            "onUpdate:value": ($event: any) => ((additional_service.value) = $event)
                          }, null, 8, ["value", "onUpdate:value"]),
                          _createVNode(_component_the_input, {
                            class: "mt-2",
                            placeholder: "Продолжительность (клиенту)",
                            value: additional_service.duration_client,
                            "onUpdate:value": ($event: any) => ((additional_service.duration_client) = $event)
                          }, null, 8, ["value", "onUpdate:value"]),
                          _createVNode(_component_the_input, {
                            class: "mt-2",
                            placeholder: "Продолжительность (себестоимость)",
                            value: additional_service.duration,
                            "onUpdate:value": ($event: any) => ((additional_service.duration) = $event)
                          }, null, 8, ["value", "onUpdate:value"]),
                          _createVNode(_component_the_input, {
                            class: "mt-2",
                            placeholder: "Себестоимость за час",
                            value: additional_service.cost_per_hour,
                            "onUpdate:value": ($event: any) => ((additional_service.cost_per_hour) = $event)
                          }, null, 8, ["value", "onUpdate:value"]),
                          _createVNode(_component_the_input, {
                            class: "mt-2",
                            placeholder: "Выставление клиенту за час",
                            value: additional_service.paid_price_per_hour,
                            "onUpdate:value": ($event: any) => ((additional_service.paid_price_per_hour) = $event)
                          }, null, 8, ["value", "onUpdate:value"]),
                          _createVNode(_component_the_input, {
                            class: "mt-2",
                            placeholder: "Общая себестоимость",
                            value: _ctx.getCostTotal(additional_service),
                            disabled: ""
                          }, null, 8, ["value"]),
                          _createVNode(_component_the_input, {
                            class: "mt-2",
                            placeholder: "Выставление клиенту",
                            value: _ctx.getPaidPriceTotal(additional_service),
                            disabled: ""
                          }, null, 8, ["value"]),
                          _createVNode(_component_the_select, {
                            class: "mt-2",
                            value: additional_service.carrier_id,
                            "onUpdate:value": [($event: any) => ((additional_service.carrier_id) = $event), 
                                    (newValue) => _ctx.onCarrierChange(newValue, additional_service)
                                ],
                            "is-invalid": !additional_service.carrier_id,
                            placeholder: "Выберите перевозчика",
                            label: "name",
                            "search-by": "name",
                            "select-by": "id",
                            options: _ctx.data_state.carriers.list,
                            loading: _ctx.data_state.carriers.is_loading,
                            failed: _ctx.data_state.carriers.is_failed,
                            "error-text": "При получении списка перевозчиков произошла ошибка",
                            "infinite-scroll": "",
                            onRefresh: _cache[14] || (_cache[14] = ($event: any) => (_ctx.loadCarriers(_ctx.data_state.carriers.pagination.current_page))),
                            onLoadmore: _cache[15] || (_cache[15] = ($event: any) => (
                                    _ctx.loadMoreCarriers(
                                        _ctx.data_state.carriers.pagination.current_page + 1
                                    )
                                ))
                          }, {
                            "selected-option": _withCtx(({ option }) => [
                              _createElementVNode("div", _hoisted_31, [
                                _createElementVNode("span", null, _toDisplayString(option.name), 1),
                                _createVNode(_component_cheap, {
                                  class: _normalizeClass(_ctx.getNdsClass(option.is_nds))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.getNdsText(option.is_nds)), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["class"])
                              ])
                            ]),
                            option: _withCtx(({ option }) => [
                              _createElementVNode("div", _hoisted_32, [
                                _createElementVNode("span", null, _toDisplayString(option.name), 1),
                                _createVNode(_component_cheap, {
                                  class: _normalizeClass(_ctx.getNdsClass(option.is_nds))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.getNdsText(option.is_nds)), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["class"])
                              ])
                            ]),
                            _: 2
                          }, 1032, ["value", "onUpdate:value", "is-invalid", "options", "loading", "failed"])
                        ]))
                      }), 128))
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_33, [
            _createVNode(_component_the_button, {
              class: "primary small",
              loading: _ctx.state.is_creating,
              onClick: _ctx.saveOrder
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Сохранить ")
              ]),
              _: 1
            }, 8, ["loading", "onClick"])
          ])
        ]))
  ]))
}